import { fetchUtil } from "@/libs/fetch";
import { NEXT_PUBLIC_GATEWAY_API_DOMAIN } from "@/libs/constants/auth";

export const fetchAllCollections = async (authToken: string) => {
  const API_URL = `${`${NEXT_PUBLIC_GATEWAY_API_DOMAIN}/mom-baby-auth/savedCollection/get`}`;

  return await fetchUtil({
    url: API_URL,
    method: "GET",
    body: {},
    useToken: true,
    token: authToken,
    credentials: "",
    ctype: "",
  });
};
